import Vue from 'vue'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import { BROWSE_JOBS, POST_A_JOB, SERVICES, VACANCIES } from '@/constants/routes'
import rolebleMixin from '@/mixins/rolebleMixin'

export default Vue.extend({
  name: 'lx-not-found',
  mixins: [rolebleMixin],
  components: {
    NoSsr,
  },
  data() {
    return {
      BROWSE_JOBS,
      POST_A_JOB,
      SERVICES,
      VACANCIES,
    }
  },
})
